import { ChangeDetectionStrategy, Component, Input, Signal, computed, effect, input } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';

import { NumpadService } from '../../../../../../../lib/numpad/numpad.service';
import { BetBuilderPick, LinearBetBuilderPickId } from '../../../../../linear-bet-builder/models';
import { selectBetBuilderPicks } from '../../../../../linear-bet-builder/selectors';
import { BetBuilderContainerStakeService } from '../../../../../linear-bet-builder/services/bet-builder-container-stake.service';
import { BetBuilderContainerSummaryService } from '../../../../../linear-bet-builder/services/bet-builder-container-summary.service';
import { RemoveButtonStyle } from '../../../../../picks/components/digital/pick-remove-button/remove-button-style';
import { LINEAR_CONTAINER_STAKE_SERVICE } from '../../../../../stake/services/digital/linear/linear-container-stake.interface';
import { LINEAR_CONTAINER_SUMMARY_SERVICE } from '../../../../../summary/services/linear/linear-container-summary.interface';
import { LinearBetBuilderComboContainerService } from '../../../../services/linear/linear-bet-builder-combo-container.service';
import { LINEAR_COMBO_BET_CONTAINER_SERVICE_INJECTION_TOKEN } from '../../../../services/linear/linear-combo-bet-container-service.interface';

@Component({
    selector: 'bs-linear-bet-builder-combo-container',
    templateUrl: './linear-bet-builder-combo-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        NumpadService,
        BetBuilderContainerStakeService,
        BetBuilderContainerSummaryService,
        LinearBetBuilderComboContainerService,
        { provide: LINEAR_COMBO_BET_CONTAINER_SERVICE_INJECTION_TOKEN, useExisting: LinearBetBuilderComboContainerService },
        { provide: LINEAR_CONTAINER_SUMMARY_SERVICE, useExisting: BetBuilderContainerSummaryService },
        { provide: LINEAR_CONTAINER_STAKE_SERVICE, useExisting: BetBuilderContainerStakeService },
    ],
    standalone: false,
})
export default class LinearBetBuilderComboContainerComponent {
    @Input() removeButtonStyle: RemoveButtonStyle;
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() selectionState: { isSelected: boolean; isLocked: boolean };

    readonly pickId = input.required<LinearBetBuilderPickId>();

    readonly currentPick: Signal<BetBuilderPick | undefined>;

    constructor(
        private containerService: LinearBetBuilderComboContainerService,
        private stakeService: BetBuilderContainerStakeService,
        private summaryService: BetBuilderContainerSummaryService,
        store: Store,
    ) {
        const betBuilderPicks = store.selectSignal(selectBetBuilderPicks);

        this.currentPick = computed(() => {
            const id = this.pickId();

            const pickList = betBuilderPicks();

            return pickList.find((p) => p.id.isEqual(id));
        });

        effect(() => {
            const pick = this.currentPick();

            this.containerService.updatePick(pick);
        });

        effect(() => {
            this.stakeService.updatePickId(this.pickId());
            this.summaryService.updatePickId(this.pickId());
        });
    }
}
